import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@ngneat/reactive-forms';
import { loadFull } from 'tsparticles';
import { Engine } from 'tsparticles-engine';
import { NewApiUserService } from '../../../api/new-api-user/new-api-user.service';
import { UtilsBsHotToastService } from '@brunsker/libs/core/utils/hot-toast/src';
import { CookiesService } from '@brunsker/libs/core/utils/cookies/src';

@Injectable({
  providedIn: 'root',
})
export class AuthDomainService {
  constructor(
    readonly newApiUserService: NewApiUserService,
    private readonly toastService: UtilsBsHotToastService,
    private cookies: CookiesService,
    readonly router: Router
  ) {}

  formGroup = new FormGroup({
    login: new FormControl<string>('', [Validators.required]),
    password: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(6),
    ]),
    rememberMe: new FormControl<boolean>(false),
  });

  async particlesInit(engine: Engine): Promise<void> {
    await loadFull(engine);
  }

  submitForm() {
    if (this.formGroup.invalid) return;
    const { login, password, rememberMe } = this.formGroup.value;
    if (rememberMe) {
      this.cookies.setCookie('login', login, 3);
      this.cookies.setCookie('password', password, 3);
    }

    this.newApiUserService
      .login({
        username: login,
        password: password,
      })
      .subscribe(() => {
        this.toastService.showSuccess('Login realizado com sucesso!');
        this.router.navigate(['/']);
      });
  }

  start(): void {
    const login = this.cookies.getCookie('login');
    const password = this.cookies.getCookie('password');
    if (login && password) {
      this.formGroup.patchValue({
        login,
        password,
      });
      this.newApiUserService
        .login({
          username: login,
          password: password,
        })
        .subscribe(() => {
          this.toastService.showSuccess('Login realizado com sucesso!');
          this.router.navigate(['/']);
        });
    }
  }
}
